import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './/app.component';
import { AppRoutingModule } from './/app-routing.module';
import { LayoutModule } from './/layouts/layout.module';
import { ScriptLoaderService } from './_services/script-loader.service';
import { DataTablesModule } from 'angular-datatables';

//Vimeo
import { KorisniciComponent } from './pages/vimeo/korisnici/korisnici.component';
import { VideozapisiComponent } from './pages/vimeo/videozapisi/videozapisi.component';
import { PravaPristupaComponent } from './pages/vimeo/prava-pristupa/prava-pristupa.component';
import { PrijavaKorisnikComponent } from './pages/vimeo/prijava-korisnik/prijava-korisnik.component';
import { VideoPlayerComponent } from './pages/vimeo/video-player/video-player.component';

//Virtualna učionica
import { UcionicaPopisComponent } from './pages/virtualna-ucionica/ucionica-popis/ucionica-popis.component';
import { UcionicaDetaljiComponent } from './pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.component';
import { PolazniciPopisComponent } from './pages/virtualna-ucionica/polaznici-popis/polaznici-popis.component';
import { VideozapisiPopisComponent } from './pages/virtualna-ucionica/videozapisi-popis/videozapisi-popis.component';
import { DokumentiPopisComponent } from './pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.component';
import { UgovoriPopisComponent } from './pages/virtualna-ucionica/ugovori-popis/ugovori-popis.component';
import { PartneriPopisComponent } from './pages/virtualna-ucionica/partneri-popis/partneri-popis.component';
import { PredavaciPopisComponent } from './pages/virtualna-ucionica/predavaci-popis/predavaci-popis.component';
import { PolaznikUcioniceComponent } from './pages/virtualna-ucionica/polaznik-ucionice/polaznik-ucionice.component';
import { PolaznikUcionicaComponent } from './pages/virtualna-ucionica/polaznik-ucionica/polaznik-ucionica.component';
import { IshodNastavneJedinicePopisComponent } from './pages/virtualna-ucionica/ishod-nastavnejedinice-popis/ishod-nastavnejedinice-popis.component';

import { MyDatePickerModule } from 'mydatepicker';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IshodiUcenjaComponent } from './pages/virtualna-ucionica/ishodiucenja-popis/ishodiucenja-popis.component';
import { NastavnejedinicePopisComponent } from './pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.component';
import { NacinpredavanjaPopisComponent } from './pages/virtualna-ucionica/nacinpredavanja-popis/nacinpredavanja-popis.component';
import { PodrucjeznanjaPopisComponent } from './pages/virtualna-ucionica/podrucjeznanja-popis/podrucjeznanja-popis.component';
import { ModuliPopisComponent } from './pages/virtualna-ucionica/moduli-popis/moduli-popis.component';
import { ZavrseneEdukacijeComponent } from './pages/virtualna-ucionica/zavrseneedukacije/zavrseneedukacije.component';
import { OtkazaneEdukacijeComponent } from './pages/virtualna-ucionica/otkazaneedukacije/otkazaneedukacije.component';
import { UvjerenjaComponent } from './pages/virtualna-ucionica/uvjerenja/uvjerenja.component';

import { ExcelService } from './pages/virtualna-ucionica/services/excel.service';
//import { DxPivotGridModule } from "devextreme-angular";
import { DevExtremeModule } from 'devextreme-angular';
import {CalendarModule} from 'primeng/calendar';


@NgModule({
  declarations: [
    AppComponent,
    KorisniciComponent,
    VideozapisiComponent,
    PravaPristupaComponent,
    PrijavaKorisnikComponent,
    VideoPlayerComponent,
    UcionicaPopisComponent,
    PolazniciPopisComponent,
    VideozapisiPopisComponent,
    DokumentiPopisComponent,
    UgovoriPopisComponent,
    PartneriPopisComponent,
    PredavaciPopisComponent,
    UcionicaDetaljiComponent,
    PolaznikUcioniceComponent,
    PolaznikUcionicaComponent,
    IshodiUcenjaComponent,
    NastavnejedinicePopisComponent,
    NacinpredavanjaPopisComponent,
    PodrucjeznanjaPopisComponent,
    ModuliPopisComponent,
    ZavrseneEdukacijeComponent,
    OtkazaneEdukacijeComponent,
    UvjerenjaComponent,
    IshodNastavneJedinicePopisComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    MyDatePickerModule,
    NguiAutoCompleteModule,
    BrowserAnimationsModule,
    //DxPivotGridModule
    DevExtremeModule,
    CalendarModule
  ],
  providers: [ScriptLoaderService, ExcelService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/app.module.ts